// extracted by mini-css-extract-plugin
export default {"obj_item":"StringifyObj_obj_item__gEqi3","fields_not_empty":"StringifyObj_fields_not_empty__rBHFc"};